/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Doc recognition error: MRZ to VIZ mismatch
 * @export
 * @interface PaxCheckMrzToVizMismatch
 */
export interface PaxCheckMrzToVizMismatch {
    /**
     * 
     * @type {string}
     * @memberof PaxCheckMrzToVizMismatch
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckMrzToVizMismatch interface.
 */
export function instanceOfPaxCheckMrzToVizMismatch(value: object): value is PaxCheckMrzToVizMismatch {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckMrzToVizMismatchFromJSON(json: any): PaxCheckMrzToVizMismatch {
    return PaxCheckMrzToVizMismatchFromJSONTyped(json, false);
}

export function PaxCheckMrzToVizMismatchFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckMrzToVizMismatch {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
    };
}

export function PaxCheckMrzToVizMismatchToJSON(json: any): PaxCheckMrzToVizMismatch {
    return PaxCheckMrzToVizMismatchToJSONTyped(json, false);
}

export function PaxCheckMrzToVizMismatchToJSONTyped(value?: PaxCheckMrzToVizMismatch | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
    };
}

